import React from "react";

export function HugeiconsReceiptDollar(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.542 22.463c.57.36.95.6 1.45.6s.88-.23 1.46-.6l1.91-1.2l.038-.024c.212-.131.527-.326.602-.326c.08.01.37.19.62.35l.068.044c.075.05.159.105.242.166h.001c.73.51 1.96 1.37 3.01.69c.81-.52.81-1.47.81-3.2V8.312c0-3.02 0-4.54-1.03-5.63c-1.05-1.12-2.59-1.12-5.37-1.12h-4.71c-2.79 0-4.32 0-5.37 1.11c-1.03 1.1-1.03 2.62-1.03 5.64v10.64c0 1.73 0 2.68.81 3.2c1.054.676 2.266-.171 2.997-.682l.012-.009q.096-.063.177-.12l.133-.09l.038-.023c.212-.131.527-.326.602-.326c.08.01.37.19.62.35zm.811-1.257l-.02-.014v.01l-1.91-1.21l-.02-.011c-.53-.334-.886-.559-1.35-.569c-.53-.02-.94.23-1.49.58c-.11.07-.23.15-.37.25c-.93.65-1.24.72-1.32.67c-.13-.18-.13-1.08-.13-1.95V8.312c0-2.63 0-3.95.62-4.61c.58-.62 1.66-.64 4.27-.64h4.71c2.61 0 3.69.02 4.27.64c.62.66.62 1.98.62 4.61v10.65c0 .87 0 1.77-.12 1.93c-.09.06-.4-.01-1.33-.66c-.14-.1-.26-.18-.37-.25l-.02-.011c-.53-.334-.886-.559-1.35-.569c-.53-.02-.94.23-1.49.58l-1.92 1.21c-.26.17-.57.37-.65.37c-.079-.01-.365-.19-.63-.356m-.11-4.893c0 .41.34.75.75.75s.75-.34.75-.75v-.75h.75c1.24 0 2.25-1.01 2.25-2.25v-.5c0-1.24-1.01-2.25-2.25-2.25h-3c-.41 0-.75-.34-.75-.75v-.5c0-.41.34-.75.75-.75h3c.41 0 .75.34.75.75s.34.75.75.75s.75-.34.75-.75c0-1.24-1.01-2.25-2.25-2.25h-.75v-.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.75h-.75c-1.24 0-2.25 1.01-2.25 2.25v.5c0 1.24 1.01 2.25 2.25 2.25h3c.41 0 .75.34.75.75v.5c0 .41-.34.75-.75.75h-3c-.41 0-.75-.34-.75-.75s-.34-.75-.75-.75s-.75.34-.75.75c0 1.24 1.01 2.25 2.25 2.25h.75z"
        color="currentColor"
      ></path>
    </svg>
  );
}

export function TablerCashRegister(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M21 15h-2.5a1.503 1.503 0 0 0-1.5 1.5a1.503 1.503 0 0 0 1.5 1.5h1a1.503 1.503 0 0 1 1.5 1.5a1.503 1.503 0 0 1-1.5 1.5H17m2 0v1m0-8v1m-6 6H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2m12 3.12V9a2 2 0 0 0-2-2h-2"></path>
        <path d="M16 10V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6m8 0H8m8 0h1m-9 0H7m1 4v.01M8 17v.01m4-3.02V14m0 3v.01"></path>
      </g>
    </svg>
  );
}

export function TablerRocket(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3-5a9 9 0 0 0 6-8a3 3 0 0 0-3-3a9 9 0 0 0-8 6a6 6 0 0 0-5 3"></path>
        <path d="M7 14a6 6 0 0 0-3 6a6 6 0 0 0 6-3m4-8a1 1 0 1 0 2 0a1 1 0 1 0-2 0"></path>
      </g>
    </svg>
  );
}
